module.exports = __webpack_public_path__ + "media/images/copy_icon-403dbf74e1fed68e50bd2e322d7c4c68.svg";